if (typeof BSS_B2B != undefined) {
  if (window.location.pathname.includes("/cart")) {
    setTimeout(async() =>{
      await BSS_B2B.storage.productStorage.load(); 
      BSS_B2B.cp?.utils.init();
      BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
    }, 1500)
  }

  if(window.location.pathname.includes("/products")) {
    setTimeout(() =>{
      const productForm = document.querySelector(".product-info.product-info--sticky");
      const formID = productForm.getAttribute("bss-b2b-product-form-id");
      if(formID) {
        const stickyBar = document.querySelector(".sticky-atc-panel");
        stickyBar.setAttribute("bss-b2b-product-form-id", formID);
        stickyBar.setAttribute("bss-b2b-product-form", "main")
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
      }
    }, 2000)
  }


  setTimeout(() =>{
    const targetMinicart = document.querySelector("cart-drawer");
    if (targetMinicart) {
        const mutationObserver = new MutationObserver(async (recordList, observe) => {
          await BSS_B2B.storage.productStorage.load(); 
          BSS_B2B.cp?.utils.init();
          BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
      });
      mutationObserver.observe(targetMinicart, { childList: true, subtree: true });
    }
  }, 1000)
}
